(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["misfit-back-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const link = document.querySelector('[data-mb-product-back]');
  if (!link || !document.referrer) return;
  try {
    const previous = new URL(document.referrer);
    const browsingCollection = /\/collections\/[^/]+\/?$/.test(previous.pathname);
    const browsingSearch = /\/search\/?$/.test(previous.pathname);
    if (previous.origin !== location.origin || (!browsingCollection && !browsingSearch)) return;
    link.href = previous.pathname + previous.search + previous.hash;
    if (browsingSearch) link.querySelector('[data-mb-back-label]').textContent = link.dataset.resultsLabel;
  } catch (error) {}
})();
  } catch(e) { console.error(e); }
})();

})();
